import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CreditCardIcon, HardHatIcon, LockIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage } from '../data/offer';
const guarantees = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep blueprint relative isolate overflow-hidden" data-id="element-127" data-mp="sbb0jammi2ao">
      <div className="hazard-bar h-3 w-full" aria-hidden="true" data-id="element-128" data-mp="sd4b310cx6ny" />

      <div className="mx-auto max-w-6xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-16" data-id="element-129" data-mp="nbf0tnkykx0x">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-safety/40 bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-safety" data-id="element-130" data-mp="3d2ldtocrhr6i">
          <HardHatIcon className="h-4 w-4" aria-hidden="true" data-id="element-131" data-mp="3o59cvlo65afl" /> Megapack Seguridad e Higiene Listo™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.04] text-white sm:text-6xl" data-id="element-132" data-mp="3e961dp7ffzfz">
          Del diagnóstico a la acción.<br data-id="element-133" data-mp="2ql6dqy5ewp5m" />
          <span className="text-safety" data-id="element-134" data-mp="2qlofgaaufvkx">Todo resuelto.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-135" data-mp="2vjpvemcz3es6">
          <img src={productImage} alt="Megapack Seguridad e Higiene Listo: nueve tomos y cinco bonos para docentes de Seguridad e Higiene en Argentina" className="mx-auto w-full drop-shadow-[0_24px_40px_rgba(2,10,25,.55)]" data-id="element-136" data-mp="s21kmih80q35" />
        </motion.div>

        <ul className="mt-8 flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-137" data-mp="dd5cklf5zd2j">
          {['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'].map(item => <li key={item} className="inline-flex items-center gap-1.5 rounded-md border border-prevention/50 bg-prevention/15 px-3 py-2" data-id="element-138" data-mp="1ayt710s27lbf">
              <CheckIcon className="h-3.5 w-3.5 text-prevention" aria-hidden="true" data-id="element-139" data-mp="1126mye7k4yag" />
              {item}
            </li>)}
        </ul>

        <div className="mt-7" data-id="element-140" data-mp="x0uywd4c0l4d">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-141" data-mp="3lsypkqaae6eu">QUIERO MI MEGAPACK AHORA</Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-142" data-mp="3hr3qztjqq74r">
          {guarantees.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="21awemc9yyxi0">
              <Icon className="h-4 w-4 text-safety" aria-hidden="true" data-id="element-144" data-mp="218tq5wogtcfe" /> {label}
            </span>)}
        </div>

        <p className="mx-auto mt-5 inline-flex max-w-2xl items-start gap-2 text-left text-xs font-semibold text-mutedDark" data-id="element-145" data-mp="2b0fwpfpuynbt">
          <UsersIcon className="mt-0.5 h-4 w-4 shrink-0 text-safety" aria-hidden="true" data-id="element-146" data-mp="2g0luldmq162c" />
          Para docentes, instructores y formadores de escuelas técnicas, formación profesional y espacios de Seguridad e
          Higiene de toda Argentina
        </p>
      </div>
    </section>;
}